<template style="height:100%">
<div>
  axa
</div>
</template>
<script>

  export default {
    data() {
      return {

      };
    },
    components:{

    },
    methods: {

    }
  };
</script>
<style>

</style>